var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "divBox" },
    [
      _c(
        "el-card",
        { staticClass: "box-card" },
        [
          _c(
            "el-form",
            {
              directives: [
                {
                  name: "loading",
                  rawName: "v-loading",
                  value: _vm.loading,
                  expression: "loading",
                },
              ],
              ref: "user",
              staticClass: "demo-ruleForm",
              attrs: {
                model: _vm.formValidate,
                rules: _vm.rules,
                "label-width": "120px",
              },
            },
            [
              _c(
                "el-row",
                [
                  _c(
                    "el-col",
                    { attrs: { span: 12 } },
                    [
                      _c(
                        "el-form-item",
                        {
                          attrs: {
                            label: _vm.$t("cpmc"),
                            prop: "product_name",
                          },
                        },
                        [
                          _c("el-input", {
                            attrs: { placeholder: _vm.$t("qsrcpmc") },
                            model: {
                              value: _vm.formValidate.product_name,
                              callback: function ($$v) {
                                _vm.$set(_vm.formValidate, "product_name", $$v)
                              },
                              expression: "formValidate.product_name",
                            },
                          }),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _c(
                    "el-col",
                    { attrs: { span: 12 } },
                    [
                      _c(
                        "el-form-item",
                        {
                          attrs: {
                            label: _vm.$t("cpdm"),
                            prop: "product_code",
                          },
                        },
                        [
                          _c("el-input", {
                            attrs: { placeholder: _vm.$t("qsrcpdm") },
                            model: {
                              value: _vm.formValidate.product_code,
                              callback: function ($$v) {
                                _vm.$set(_vm.formValidate, "product_code", $$v)
                              },
                              expression: "formValidate.product_code",
                            },
                          }),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                ],
                1
              ),
              _vm._v(" "),
              _c(
                "el-row",
                [
                  _c(
                    "el-col",
                    { attrs: { span: 24 } },
                    [
                      _c(
                        "el-form-item",
                        { attrs: { label: _vm.$t("sort"), prop: "sort" } },
                        [
                          _c("el-input", {
                            attrs: { placeholder: _vm.$t("qsrpx") },
                            model: {
                              value: _vm.formValidate.sort,
                              callback: function ($$v) {
                                _vm.$set(_vm.formValidate, "sort", $$v)
                              },
                              expression: "formValidate.sort",
                            },
                          }),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                ],
                1
              ),
              _vm._v(" "),
              _c(
                "el-row",
                [
                  _c(
                    "el-col",
                    { attrs: { span: 12 } },
                    [
                      _c(
                        "el-form-item",
                        { attrs: { label: _vm.$t("source"), prop: "source" } },
                        [
                          _c(
                            "el-radio-group",
                            {
                              model: {
                                value: _vm.formValidate.source,
                                callback: function ($$v) {
                                  _vm.$set(_vm.formValidate, "source", $$v)
                                },
                                expression: "formValidate.source",
                              },
                            },
                            [
                              _c(
                                "el-radio",
                                { attrs: { label: _vm.$t("xinlang") } },
                                [_vm._v(_vm._s(_vm.$t("xinlang")))]
                              ),
                              _vm._v(" "),
                              _c(
                                "el-radio",
                                { attrs: { label: _vm.$t("huobi") } },
                                [_vm._v(_vm._s(_vm.$t("huobi")))]
                              ),
                            ],
                            1
                          ),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _c(
                    "el-col",
                    { attrs: { span: 6 } },
                    [
                      _c(
                        "el-form-item",
                        {
                          attrs: {
                            label: _vm.$t("yingli"),
                            prop: "profit_status",
                          },
                        },
                        [
                          _c(
                            "el-select",
                            {
                              staticStyle: { width: "100%" },
                              model: {
                                value: _vm.formValidate.profit_status,
                                callback: function ($$v) {
                                  _vm.$set(
                                    _vm.formValidate,
                                    "profit_status",
                                    $$v
                                  )
                                },
                                expression: "formValidate.profit_status",
                              },
                            },
                            [
                              _c("el-option", {
                                attrs: { label: _vm.$t("kaiqi"), value: 1 },
                              }),
                              _vm._v(" "),
                              _c("el-option", {
                                attrs: { label: _vm.$t("guanbi"), value: 0 },
                              }),
                            ],
                            1
                          ),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _c(
                    "el-col",
                    { attrs: { span: 6 } },
                    [
                      _c(
                        "el-form-item",
                        {
                          attrs: {
                            label: _vm.$t("kuisun"),
                            prop: "low_status",
                          },
                        },
                        [
                          _c(
                            "el-select",
                            {
                              staticStyle: { width: "100%" },
                              model: {
                                value: _vm.formValidate.low_status,
                                callback: function ($$v) {
                                  _vm.$set(_vm.formValidate, "low_status", $$v)
                                },
                                expression: "formValidate.low_status",
                              },
                            },
                            [
                              _c("el-option", {
                                attrs: { label: _vm.$t("kaiqi"), value: 1 },
                              }),
                              _vm._v(" "),
                              _c("el-option", {
                                attrs: { label: _vm.$t("guanbi"), value: 0 },
                              }),
                            ],
                            1
                          ),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                ],
                1
              ),
              _vm._v(" "),
              _c(
                "div",
                { staticClass: "box-item-area" },
                [
                  _c(
                    "el-row",
                    [
                      _c(
                        "el-col",
                        { attrs: { span: 24 } },
                        [
                          _c(
                            "el-form-item",
                            { attrs: { label: _vm.$t("cptp"), prop: "logo" } },
                            [
                              _c(
                                "div",
                                {
                                  staticClass:
                                    "acea-row upLoadPicBox row-middle",
                                },
                                [
                                  _c(
                                    "el-upload",
                                    {
                                      staticClass: "upload-demo",
                                      attrs: {
                                        action: "",
                                        "http-request": _vm.handleUploadForm,
                                        headers: _vm.myHeaders,
                                        "show-file-list": false,
                                      },
                                    },
                                    [
                                      _vm.formValidate.logo
                                        ? _c(
                                            "div",
                                            { staticClass: "pictrue" },
                                            [
                                              _c("img", {
                                                attrs: {
                                                  src: _vm.setUrl(
                                                    _vm.formValidate.logo
                                                  ),
                                                },
                                              }),
                                            ]
                                          )
                                        : _c("div", { staticClass: "upLoad" }, [
                                            _c("i", {
                                              staticClass:
                                                "el-icon-camera cameraIconfont",
                                            }),
                                          ]),
                                    ]
                                  ),
                                ],
                                1
                              ),
                            ]
                          ),
                        ],
                        1
                      ),
                      _vm._v(" "),
                      _c(
                        "el-col",
                        { attrs: { span: 24 } },
                        [
                          _c(
                            "el-form-item",
                            {
                              attrs: {
                                label: _vm.$t("cpremark"),
                                prop: "remark",
                              },
                            },
                            [
                              _c("el-input", {
                                attrs: { placeholder: _vm.$t("qsrremark") },
                                model: {
                                  value: _vm.formValidate.remark,
                                  callback: function ($$v) {
                                    _vm.$set(_vm.formValidate, "remark", $$v)
                                  },
                                  expression: "formValidate.remark",
                                },
                              }),
                            ],
                            1
                          ),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                ],
                1
              ),
              _vm._v(" "),
              _c(
                "div",
                { staticClass: "box-item-area" },
                [
                  _c(
                    "el-row",
                    [
                      _c("el-col", { attrs: { span: 24 } }, [
                        _c(
                          "p",
                          { staticClass: "warning-text margin_bottom_8" },
                          [
                            _vm._v(
                              "\n                " +
                                _vm._s(_vm.$t("ddzy")) +
                                "\n              "
                            ),
                          ]
                        ),
                      ]),
                      _vm._v(" "),
                      _c(
                        "el-col",
                        { attrs: { span: 12 } },
                        [
                          _c(
                            "el-form-item",
                            {
                              staticStyle: { "margin-bottom": "0" },
                              attrs: {
                                label: _vm.$t("fkzxbdz"),
                                prop: "fkzxbdz",
                              },
                            },
                            [
                              _c("el-input", {
                                attrs: { placeholder: _vm.$t("qsrfkzxbdz") },
                                model: {
                                  value: _vm.formValidate.fkzxbdz,
                                  callback: function ($$v) {
                                    _vm.$set(_vm.formValidate, "fkzxbdz", $$v)
                                  },
                                  expression: "formValidate.fkzxbdz",
                                },
                              }),
                            ],
                            1
                          ),
                        ],
                        1
                      ),
                      _vm._v(" "),
                      _c(
                        "el-col",
                        { attrs: { span: 12 } },
                        [
                          _c(
                            "el-form-item",
                            {
                              staticStyle: { "margin-bottom": "0" },
                              attrs: {
                                label: _vm.$t("fkzdbdz"),
                                prop: "fkzdbdz",
                              },
                            },
                            [
                              _c("el-input", {
                                attrs: { placeholder: _vm.$t("qsrfkzdbdz") },
                                model: {
                                  value: _vm.formValidate.fkzdbdz,
                                  callback: function ($$v) {
                                    _vm.$set(_vm.formValidate, "fkzdbdz", $$v)
                                  },
                                  expression: "formValidate.fkzdbdz",
                                },
                              }),
                            ],
                            1
                          ),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                ],
                1
              ),
              _vm._v(" "),
              _c(
                "div",
                { staticClass: "box-item-area" },
                [
                  _c(
                    "el-row",
                    [
                      _c("el-col", { attrs: { span: 24 } }, [
                        _c(
                          "p",
                          { staticClass: "warning-text margin_bottom_8" },
                          [
                            _vm._v(
                              "\n                " +
                                _vm._s(_vm.$t("cpzy")) +
                                "\n              "
                            ),
                          ]
                        ),
                      ]),
                      _vm._v(" "),
                      _c(
                        "el-col",
                        { attrs: { span: 24 } },
                        [
                          _c(
                            "el-form-item",
                            {
                              staticStyle: { "margin-bottom": "0" },
                              attrs: {
                                label: _vm.$t("sjbdwf"),
                                prop: "sjbdfw",
                              },
                            },
                            [
                              _c("el-input", {
                                attrs: { placeholder: _vm.$t("qsrsjbdwf") },
                                model: {
                                  value: _vm.formValidate.sjbdfw,
                                  callback: function ($$v) {
                                    _vm.$set(_vm.formValidate, "sjbdfw", $$v)
                                  },
                                  expression: "formValidate.sjbdfw",
                                },
                              }),
                            ],
                            1
                          ),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                ],
                1
              ),
              _vm._v(" "),
              _c(
                "div",
                { staticClass: "box-item-area" },
                [
                  _c(
                    "el-row",
                    [
                      _c(
                        "el-col",
                        { attrs: { span: 24 } },
                        [
                          _c(
                            "el-form-item",
                            {
                              staticStyle: { "margin-bottom": "0" },
                              attrs: {
                                label: _vm.$t("wfms"),
                                prop: "mode_type",
                              },
                            },
                            [
                              _c(
                                "el-radio-group",
                                {
                                  model: {
                                    value: _vm.formValidate.mode_type,
                                    callback: function ($$v) {
                                      _vm.$set(
                                        _vm.formValidate,
                                        "mode_type",
                                        $$v
                                      )
                                    },
                                    expression: "formValidate.mode_type",
                                  },
                                },
                                [
                                  _c("el-radio", { attrs: { label: 1 } }, [
                                    _vm._v(_vm._s(_vm.$t("azsjszpl"))),
                                  ]),
                                  _vm._v(" "),
                                  _c("el-radio", { attrs: { label: 2 } }, [
                                    _vm._v(_vm._s(_vm.$t("azjeszpl"))),
                                  ]),
                                ],
                                1
                              ),
                            ],
                            1
                          ),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                ],
                1
              ),
              _vm._v(" "),
              _c(
                "div",
                { staticClass: "box-item-area" },
                [
                  _c(
                    "el-row",
                    { staticClass: "margin_bottom_20" },
                    [
                      _c("el-col", { attrs: { span: 24 } }, [
                        _c(
                          "p",
                          { staticClass: "warning-text margin_bottom_8" },
                          [
                            _vm._v(
                              "\n                  " +
                                _vm._s(_vm.$t("wfzy")) +
                                "\n                "
                            ),
                          ]
                        ),
                      ]),
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _vm.formValidate.mode_type == 1
                    ? _c(
                        "div",
                        [
                          _vm.formValidate.mode_type == 1
                            ? _c(
                                "p",
                                { staticClass: "margin_bottom_8  flex-end" },
                                [
                                  _c(
                                    "el-button",
                                    {
                                      attrs: {
                                        type: "primary",
                                        size: "small",
                                        plain: "",
                                      },
                                      on: {
                                        click: function ($event) {
                                          return _vm.addMode("time_scheme_list")
                                        },
                                      },
                                    },
                                    [_vm._v(_vm._s(_vm.$t("xzwf")))]
                                  ),
                                ],
                                1
                              )
                            : _vm._e(),
                          _vm._v(" "),
                          _vm._l(
                            _vm.time_scheme_list,
                            function (item, schemeIndex) {
                              return _c(
                                "el-row",
                                { key: schemeIndex },
                                [
                                  _c("el-col", { attrs: { span: 24 } }, [
                                    _c(
                                      "p",
                                      {
                                        staticClass:
                                          "margin_bottom_8 font_16 flex-justify",
                                      },
                                      [
                                        _vm._v(
                                          "\n                  " +
                                            _vm._s(_vm.$t("wanfa")) +
                                            " " +
                                            _vm._s(schemeIndex + 1) +
                                            "\n                  "
                                        ),
                                        _c(
                                          "el-link",
                                          {
                                            attrs: {
                                              type: "danger",
                                              underline: false,
                                            },
                                            on: {
                                              click: function ($event) {
                                                return _vm.handleDelete(
                                                  schemeIndex,
                                                  "time_scheme_list"
                                                )
                                              },
                                            },
                                          },
                                          [_vm._v(_vm._s(_vm.$t("deletetext")))]
                                        ),
                                      ],
                                      1
                                    ),
                                  ]),
                                  _vm._v(" "),
                                  _c(
                                    "div",
                                    { staticClass: "time-mode" },
                                    [
                                      _c(
                                        "el-col",
                                        { attrs: { span: 12 } },
                                        [
                                          _c(
                                            "el-form-item",
                                            {
                                              staticStyle: {
                                                "margin-bottom": "10px",
                                              },
                                              attrs: { label: _vm.$t("sjfw") },
                                            },
                                            [
                                              _c(
                                                "el-input",
                                                {
                                                  attrs: {
                                                    type: "number",
                                                    placeholder:
                                                      _vm.$t("qsrsjfw"),
                                                  },
                                                  model: {
                                                    value: item.time,
                                                    callback: function ($$v) {
                                                      _vm.$set(
                                                        item,
                                                        "time",
                                                        $$v
                                                      )
                                                    },
                                                    expression: "item.time",
                                                  },
                                                },
                                                [
                                                  _c(
                                                    "template",
                                                    { slot: "append" },
                                                    [
                                                      _vm._v(
                                                        _vm._s(_vm.$t("miao"))
                                                      ),
                                                    ]
                                                  ),
                                                ],
                                                2
                                              ),
                                            ],
                                            1
                                          ),
                                        ],
                                        1
                                      ),
                                      _vm._v(" "),
                                      _c(
                                        "el-col",
                                        { attrs: { span: 12 } },
                                        [
                                          _c(
                                            "el-form-item",
                                            {
                                              staticStyle: {
                                                "margin-bottom": "10px",
                                              },
                                              attrs: {
                                                label: _vm.$t("xzjeqj"),
                                              },
                                            },
                                            [
                                              _c(
                                                "div",
                                                { staticClass: "flex-start" },
                                                [
                                                  _c("el-input", {
                                                    staticStyle: {
                                                      width: "140px",
                                                      "margin-right": "5px",
                                                    },
                                                    attrs: {
                                                      type: "number",
                                                      placeholder:
                                                        _vm.$t("zxxzje"),
                                                    },
                                                    model: {
                                                      value:
                                                        item.min_invest_money,
                                                      callback: function ($$v) {
                                                        _vm.$set(
                                                          item,
                                                          "min_invest_money",
                                                          $$v
                                                        )
                                                      },
                                                      expression:
                                                        "item.min_invest_money",
                                                    },
                                                  }),
                                                  _vm._v(
                                                    "\n                      -\n                      "
                                                  ),
                                                  _c("el-input", {
                                                    staticStyle: {
                                                      width: "140px",
                                                      "margin-left": "5px",
                                                    },
                                                    attrs: {
                                                      type: "number",
                                                      placeholder:
                                                        _vm.$t("zdxzje"),
                                                    },
                                                    model: {
                                                      value:
                                                        item.max_invest_money,
                                                      callback: function ($$v) {
                                                        _vm.$set(
                                                          item,
                                                          "max_invest_money",
                                                          $$v
                                                        )
                                                      },
                                                      expression:
                                                        "item.max_invest_money",
                                                    },
                                                  }),
                                                ],
                                                1
                                              ),
                                            ]
                                          ),
                                        ],
                                        1
                                      ),
                                      _vm._v(" "),
                                      _c(
                                        "el-col",
                                        { attrs: { span: 12 } },
                                        [
                                          _c(
                                            "el-form-item",
                                            {
                                              staticStyle: {
                                                "margin-bottom": "10",
                                              },
                                              attrs: {
                                                label: _vm.$t("ylblqj"),
                                              },
                                            },
                                            [
                                              _c("el-input", {
                                                attrs: {
                                                  placeholder: _vm.$t("ylblqj"),
                                                },
                                                model: {
                                                  value: item.profit_rate,
                                                  callback: function ($$v) {
                                                    _vm.$set(
                                                      item,
                                                      "profit_rate",
                                                      $$v
                                                    )
                                                  },
                                                  expression:
                                                    "item.profit_rate",
                                                },
                                              }),
                                            ],
                                            1
                                          ),
                                        ],
                                        1
                                      ),
                                      _vm._v(" "),
                                      _c(
                                        "el-col",
                                        { attrs: { span: 12 } },
                                        [
                                          _c(
                                            "el-form-item",
                                            {
                                              staticStyle: {
                                                "margin-bottom": "10",
                                              },
                                              attrs: {
                                                label: _vm.$t("ksblqj"),
                                              },
                                            },
                                            [
                                              _c("el-input", {
                                                attrs: {
                                                  placeholder: _vm.$t("ksblqj"),
                                                },
                                                model: {
                                                  value: item.loss_rate,
                                                  callback: function ($$v) {
                                                    _vm.$set(
                                                      item,
                                                      "loss_rate",
                                                      $$v
                                                    )
                                                  },
                                                  expression: "item.loss_rate",
                                                },
                                              }),
                                            ],
                                            1
                                          ),
                                        ],
                                        1
                                      ),
                                    ],
                                    1
                                  ),
                                ],
                                1
                              )
                            }
                          ),
                        ],
                        2
                      )
                    : _vm._e(),
                  _vm._v(" "),
                  _vm.formValidate.mode_type == 2
                    ? _c(
                        "div",
                        [
                          _c(
                            "p",
                            { staticClass: "margin_bottom_8  flex-end" },
                            [
                              _c(
                                "el-button",
                                {
                                  attrs: {
                                    type: "primary",
                                    size: "small",
                                    plain: "",
                                  },
                                  on: {
                                    click: function ($event) {
                                      return _vm.addMode("timeModeList")
                                    },
                                  },
                                },
                                [_vm._v(_vm._s(_vm.$t("xzsjfw")))]
                              ),
                            ],
                            1
                          ),
                          _vm._v(" "),
                          _c(
                            "p",
                            {
                              staticClass: "margin_bottom_8 font_16 flex-start",
                            },
                            [
                              _vm._v(
                                "\n              " +
                                  _vm._s(_vm.$t("sjwfsz")) +
                                  "\n            "
                              ),
                            ]
                          ),
                          _vm._v(" "),
                          _vm._l(_vm.timeModeList, function (item, timeIndex) {
                            return _c(
                              "el-row",
                              { key: timeIndex },
                              [
                                _c("el-col", { attrs: { span: 24 } }, [
                                  _c(
                                    "p",
                                    {
                                      staticClass:
                                        "margin_bottom_20 font_16 flex-end",
                                    },
                                    [
                                      _c(
                                        "el-link",
                                        {
                                          attrs: {
                                            type: "danger",
                                            underline: false,
                                          },
                                          on: {
                                            click: function ($event) {
                                              return _vm.handleDelete(
                                                timeIndex,
                                                "timeModeList"
                                              )
                                            },
                                          },
                                        },
                                        [_vm._v(_vm._s(_vm.$t("deletetext")))]
                                      ),
                                    ],
                                    1
                                  ),
                                ]),
                                _vm._v(" "),
                                _c(
                                  "div",
                                  { staticClass: "jine-mode" },
                                  [
                                    _c(
                                      "el-col",
                                      { attrs: { span: 12 } },
                                      [
                                        _c(
                                          "el-form-item",
                                          {
                                            staticStyle: {
                                              "margin-bottom": "10px",
                                            },
                                            attrs: { label: _vm.$t("sjfw") },
                                          },
                                          [
                                            _c(
                                              "el-input",
                                              {
                                                attrs: {
                                                  type: "number",
                                                  placeholder:
                                                    _vm.$t("qsrsjfw"),
                                                },
                                                model: {
                                                  value: item.time,
                                                  callback: function ($$v) {
                                                    _vm.$set(item, "time", $$v)
                                                  },
                                                  expression: "item.time",
                                                },
                                              },
                                              [
                                                _c(
                                                  "template",
                                                  { slot: "append" },
                                                  [
                                                    _vm._v(
                                                      _vm._s(_vm.$t("miao"))
                                                    ),
                                                  ]
                                                ),
                                              ],
                                              2
                                            ),
                                          ],
                                          1
                                        ),
                                      ],
                                      1
                                    ),
                                    _vm._v(" "),
                                    _c(
                                      "el-col",
                                      { attrs: { span: 12 } },
                                      [
                                        _c(
                                          "el-form-item",
                                          {
                                            staticStyle: {
                                              "margin-bottom": "10px",
                                            },
                                            attrs: { label: _vm.$t("zDxzje") },
                                          },
                                          [
                                            _c(
                                              "div",
                                              { staticClass: "flex-start" },
                                              [
                                                _c("el-input", {
                                                  staticStyle: {
                                                    width: "140px",
                                                    "margin-right": "5px",
                                                  },
                                                  attrs: {
                                                    type: "number",
                                                    placeholder:
                                                      _vm.$t("zxxzje"),
                                                  },
                                                  model: {
                                                    value:
                                                      item.min_invest_money,
                                                    callback: function ($$v) {
                                                      _vm.$set(
                                                        item,
                                                        "min_invest_money",
                                                        $$v
                                                      )
                                                    },
                                                    expression:
                                                      "item.min_invest_money",
                                                  },
                                                }),
                                                _vm._v(
                                                  "\n                      -\n                      "
                                                ),
                                                _c("el-input", {
                                                  staticStyle: {
                                                    width: "140px",
                                                    "margin-left": "5px",
                                                  },
                                                  attrs: {
                                                    type: "number",
                                                    placeholder:
                                                      _vm.$t("zdxzje"),
                                                  },
                                                  model: {
                                                    value:
                                                      item.max_invest_money,
                                                    callback: function ($$v) {
                                                      _vm.$set(
                                                        item,
                                                        "max_invest_money",
                                                        $$v
                                                      )
                                                    },
                                                    expression:
                                                      "item.max_invest_money",
                                                  },
                                                }),
                                              ],
                                              1
                                            ),
                                          ]
                                        ),
                                      ],
                                      1
                                    ),
                                  ],
                                  1
                                ),
                              ],
                              1
                            )
                          }),
                        ],
                        2
                      )
                    : _vm._e(),
                  _vm._v(" "),
                  _vm.formValidate.mode_type == 2
                    ? _c(
                        "div",
                        [
                          _c(
                            "p",
                            { staticClass: "margin_bottom_20  flex-end" },
                            [
                              _c(
                                "el-button",
                                {
                                  attrs: {
                                    type: "primary",
                                    size: "small",
                                    plain: "",
                                  },
                                  on: {
                                    click: function ($event) {
                                      return _vm.addMode("modeList")
                                    },
                                  },
                                },
                                [_vm._v(_vm._s(_vm.$t("xzjepl")))]
                              ),
                            ],
                            1
                          ),
                          _vm._v(" "),
                          _vm._l(_vm.modeList, function (item, sunIndex) {
                            return _c(
                              "el-row",
                              { key: sunIndex },
                              [
                                _c("el-col", { attrs: { span: 24 } }, [
                                  _c(
                                    "p",
                                    {
                                      staticClass:
                                        "margin_bottom_8 font_16 flex-justify",
                                    },
                                    [
                                      _vm._v(
                                        "\n                  " +
                                          _vm._s(_vm.$t("jeplsz")) +
                                          _vm._s(sunIndex + 1) +
                                          "\n                  "
                                      ),
                                      _c(
                                        "el-link",
                                        {
                                          attrs: {
                                            type: "danger",
                                            underline: false,
                                          },
                                          on: {
                                            click: function ($event) {
                                              return _vm.handleDelete(
                                                sunIndex,
                                                "modeList"
                                              )
                                            },
                                          },
                                        },
                                        [_vm._v(_vm._s(_vm.$t("deletetext")))]
                                      ),
                                    ],
                                    1
                                  ),
                                ]),
                                _vm._v(" "),
                                _c(
                                  "div",
                                  { staticClass: "jine-mode" },
                                  [
                                    _c(
                                      "el-col",
                                      { attrs: { span: 24 } },
                                      [
                                        _c(
                                          "el-form-item",
                                          {
                                            staticStyle: {
                                              "margin-bottom": "10px",
                                            },
                                            attrs: { label: _vm.$t("xzjeqj") },
                                          },
                                          [
                                            _c(
                                              "div",
                                              { staticClass: "flex-start" },
                                              [
                                                _c("el-input", {
                                                  staticStyle: {
                                                    width: "140px",
                                                    "margin-right": "5px",
                                                  },
                                                  attrs: {
                                                    type: "number",
                                                    placeholder:
                                                      _vm.$t("zxxzje"),
                                                  },
                                                  model: {
                                                    value:
                                                      item.min_invest_money,
                                                    callback: function ($$v) {
                                                      _vm.$set(
                                                        item,
                                                        "min_invest_money",
                                                        $$v
                                                      )
                                                    },
                                                    expression:
                                                      "item.min_invest_money",
                                                  },
                                                }),
                                                _vm._v(
                                                  "\n                      -\n                      "
                                                ),
                                                _c("el-input", {
                                                  staticStyle: {
                                                    width: "140px",
                                                    "margin-left": "5px",
                                                  },
                                                  attrs: {
                                                    type: "number",
                                                    placeholder:
                                                      _vm.$t("zdxzje"),
                                                  },
                                                  model: {
                                                    value:
                                                      item.max_invest_money,
                                                    callback: function ($$v) {
                                                      _vm.$set(
                                                        item,
                                                        "max_invest_money",
                                                        $$v
                                                      )
                                                    },
                                                    expression:
                                                      "item.max_invest_money",
                                                  },
                                                }),
                                              ],
                                              1
                                            ),
                                          ]
                                        ),
                                      ],
                                      1
                                    ),
                                    _vm._v(" "),
                                    _c(
                                      "el-col",
                                      { attrs: { span: 12 } },
                                      [
                                        _c(
                                          "el-form-item",
                                          {
                                            staticStyle: {
                                              "margin-bottom": "10",
                                            },
                                            attrs: { label: _vm.$t("ylblqj") },
                                          },
                                          [
                                            _c("el-input", {
                                              attrs: {
                                                placeholder: _vm.$t("ylblqj"),
                                              },
                                              model: {
                                                value: item.profit_rate,
                                                callback: function ($$v) {
                                                  _vm.$set(
                                                    item,
                                                    "profit_rate",
                                                    $$v
                                                  )
                                                },
                                                expression: "item.profit_rate",
                                              },
                                            }),
                                          ],
                                          1
                                        ),
                                      ],
                                      1
                                    ),
                                    _vm._v(" "),
                                    _c(
                                      "el-col",
                                      { attrs: { span: 12 } },
                                      [
                                        _c(
                                          "el-form-item",
                                          {
                                            staticStyle: {
                                              "margin-bottom": "10",
                                            },
                                            attrs: { label: _vm.$t("ksblqj") },
                                          },
                                          [
                                            _c("el-input", {
                                              attrs: {
                                                placeholder: _vm.$t("ksblqj"),
                                              },
                                              model: {
                                                value: item.loss_rate,
                                                callback: function ($$v) {
                                                  _vm.$set(
                                                    item,
                                                    "loss_rate",
                                                    $$v
                                                  )
                                                },
                                                expression: "item.loss_rate",
                                              },
                                            }),
                                          ],
                                          1
                                        ),
                                      ],
                                      1
                                    ),
                                  ],
                                  1
                                ),
                              ],
                              1
                            )
                          }),
                        ],
                        2
                      )
                    : _vm._e(),
                ],
                1
              ),
              _vm._v(" "),
              _c(
                "div",
                { staticClass: "box-item-area" },
                [
                  _c(
                    "el-row",
                    { staticClass: "margin_bottom_20" },
                    [
                      _c("el-col", { attrs: { span: 24 } }, [
                        _c(
                          "p",
                          {
                            staticClass:
                              "margin_bottom_20 font_16 flex-justify",
                          },
                          [
                            _vm._v(
                              "\n                " +
                                _vm._s(_vm.$t("kssjzy")) +
                                "\n              "
                            ),
                          ]
                        ),
                      ]),
                      _vm._v(" "),
                      _vm._l(_vm.startTimeList, function (item, index) {
                        return _c(
                          "el-col",
                          { key: index, attrs: { span: 12 } },
                          [
                            _c(
                              "el-form-item",
                              {
                                staticStyle: {
                                  "margin-bottom": "10px",
                                  display: "flex",
                                  "justify-content": "flex-start",
                                },
                                attrs: { "label-width": "0" },
                              },
                              [
                                _c(
                                  "el-select",
                                  {
                                    staticStyle: { width: "200px" },
                                    attrs: {
                                      multiple: "",
                                      "collapse-tags": "",
                                      placeholder: _vm.$t("qxz"),
                                    },
                                    model: {
                                      value: item.time,
                                      callback: function ($$v) {
                                        _vm.$set(item, "time", $$v)
                                      },
                                      expression: "item.time",
                                    },
                                  },
                                  [
                                    _c("el-option", {
                                      attrs: {
                                        label: _vm.$t("zhouyi"),
                                        value: "1",
                                      },
                                    }),
                                    _vm._v(" "),
                                    _c("el-option", {
                                      attrs: {
                                        label: _vm.$t("zhouer"),
                                        value: "2",
                                      },
                                    }),
                                    _vm._v(" "),
                                    _c("el-option", {
                                      attrs: {
                                        label: _vm.$t("zhousan"),
                                        value: "3",
                                      },
                                    }),
                                    _vm._v(" "),
                                    _c("el-option", {
                                      attrs: {
                                        label: _vm.$t("zhousi"),
                                        value: "4",
                                      },
                                    }),
                                    _vm._v(" "),
                                    _c("el-option", {
                                      attrs: {
                                        label: _vm.$t("zhouwu"),
                                        value: "5",
                                      },
                                    }),
                                    _vm._v(" "),
                                    _c("el-option", {
                                      attrs: {
                                        label: _vm.$t("zhouliu"),
                                        value: "6",
                                      },
                                    }),
                                    _vm._v(" "),
                                    _c("el-option", {
                                      attrs: {
                                        label: _vm.$t("zhouri"),
                                        value: "7",
                                      },
                                    }),
                                  ],
                                  1
                                ),
                                _vm._v(" "),
                                _c("el-time-picker", {
                                  staticStyle: {
                                    "margin-left": "7px",
                                    width: "140px",
                                  },
                                  attrs: {
                                    editable: "",
                                    format: "HH:mm:ss",
                                    "value-format": "HH:mm:ss",
                                    placeholder: _vm.$t("startTime"),
                                  },
                                  model: {
                                    value: item.start,
                                    callback: function ($$v) {
                                      _vm.$set(item, "start", $$v)
                                    },
                                    expression: "item.start",
                                  },
                                }),
                                _vm._v(" "),
                                _c(
                                  "span",
                                  { staticStyle: { margin: "0 10px" } },
                                  [_vm._v("~")]
                                ),
                                _vm._v(" "),
                                _c("el-time-picker", {
                                  staticStyle: { width: "140px" },
                                  attrs: {
                                    editable: "",
                                    format: "HH:mm:ss",
                                    "value-format": "HH:mm:ss",
                                    placeholder: _vm.$t("endTime"),
                                  },
                                  model: {
                                    value: item.end,
                                    callback: function ($$v) {
                                      _vm.$set(item, "end", $$v)
                                    },
                                    expression: "item.end",
                                  },
                                }),
                              ],
                              1
                            ),
                          ],
                          1
                        )
                      }),
                    ],
                    2
                  ),
                ],
                1
              ),
            ],
            1
          ),
          _vm._v(" "),
          _c(
            "div",
            { staticClass: "dialog-footer flex-end" },
            [
              _c(
                "el-button",
                {
                  on: {
                    click: function ($event) {
                      return _vm.resetForm("user")
                    },
                  },
                },
                [_vm._v(_vm._s(_vm.$t("calcelText")))]
              ),
              _vm._v(" "),
              _c(
                "el-button",
                {
                  attrs: { type: "primary" },
                  on: {
                    click: function ($event) {
                      return _vm.submitForm("formValidate")
                    },
                  },
                },
                [_vm._v(_vm._s(_vm.$t("trueText")))]
              ),
            ],
            1
          ),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }